var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{ref:"dialog",attrs:{"lazy":"","absolute":"","persistent":_vm.persistent,"max-width":_vm.width},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }